





































import { Component, Vue, Ref, Watch, Prop } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import { ITodoTypeOptions, todoTypeTool } from '@/utils/todo';
import { generateUUID } from '@/utils/other';


type ISettlementUnitInfo = ISettlementUnit.IResponse.ISettlementUnitInfo;

interface IForm {
  title: string;
  typeId: string[];
  typeName: string;
  settlementUnitId: string;
  settlementUnitName: string;
  manDay: number | null;
  description: string;
}
export interface IFormItemInfo extends IForm {
  formId: string;
}

export function createNewFormItem(params?: Partial<IFormItemInfo>) {
  const baseFormItem: IFormItemInfo = {
    formId: generateUUID(),
    typeId: [],
    typeName: '',
    settlementUnitId: '',
    settlementUnitName: '',
    title: '',
    description: '',
    manDay: null,
  };
  if (params) {
    return Object.assign(baseFormItem, params);
  }
  return baseFormItem;
}


@Component({
  components: {},
})
export default class TemplateTodoForm extends Vue {
  @Ref() private readonly editTodoForm!: FormModel;
  @Prop({default: () => '', required: true}) private readonly projectId!: string;
  @Prop({default: () => null}) private readonly formInfo!: IFormItemInfo | null;
  @Prop({default: () => [], required: true}) private readonly settlementUnitOptions!: ISettlementUnitInfo[];
  @Prop({default: () => [], required: true}) private readonly todoTypeOptions!: ITodoTypeOptions[];
  private typeFormat: number = 2;
  private form: IForm = {
    typeId: [],
    typeName: '',
    settlementUnitId: '',
    settlementUnitName: '',
    title: '',
    description: '',
    manDay: null,
  };
  get rules() {
    return {
      title: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      typeId: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      settlementUnitId: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      manDay: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
    };
  }
  public validate() {
    let validateResult: boolean = false;
    this.editTodoForm.validate((valid) => {
      validateResult = valid;
    });
    return validateResult;
  }
  public generateTodoData(): IModule.IRequest.IModuleTemplateTodo {
    const {typeId, typeName, title, manDay, description, settlementUnitId, settlementUnitName} = this.form;
    return {
      typeId: typeId[typeId.length - 1],
      typeName,
      title,
      manDay: manDay || 0,
      description,
      status: 0,
      todoStatus: 'Processing',
      settlementConfigurationId: settlementUnitId,
      settlementConfigurationName: settlementUnitName,
    };
  }
  private created() {
    this.readyFormData();
  }
  @Watch('projectId')
  private watchProjectId(newValue: string) {
    this.form.typeId = [];
    this.form.typeName = '';
  }
  private readyFormData() {
    this.form = {
      title: '',
      typeId: [],
      typeName: '',
      settlementUnitId: '',
      settlementUnitName: '',
      description: '',
      manDay: null,
    };
    if (this.formInfo) {
      this.form = {
        ...this.formInfo,
      };
      this.updateTypeFormat(this.formInfo.typeId);
    }
  }
  private onTypeChange(value: string[], selectedOptions: ITodoTypeOptions[]) {
    if (value.length === 0) {
      this.form.typeName = '';
      return;
    }
    this.form.typeName = selectedOptions[selectedOptions.length - 1].label;
    this.updateTypeFormat(value);
  }
  private onSettlementUnitChange(value: string) {
    if (value) {
      this.form.settlementUnitName = this.settlementUnitOptions.find((item) => item.id === value)!.name;
    } else {
      this.form.settlementUnitName = '';
    }
  }
  private updateTypeFormat(typeId: string[]) {
    if (typeId.length === 0) {
      return;
    }
    const TodoType = todoTypeTool.getTodoTypeById(typeId[typeId.length - 1]);
    if (TodoType) {
      this.typeFormat = TodoType.formatType === 1 ? 0 : 2;
    } else {
      this.typeFormat = 2;
    }
  }
  private removeForm() {
    this.$emit('remove');
  }
  private copyForm() {
    const formItemInfo: IFormItemInfo = {
      formId: '',
      ...this.form,
    };
    this.$emit('copy', formItemInfo);
  }
}
